import http from 'hub-http/clients/apiClient';
import { CRM_SEARCH_URL } from '../constants/urls';
const createPayload = (audienceId, overrides = {}) => Object.assign({
  query: '',
  count: 1,
  offset: 0,
  objectTypeId: '0-156',
  requestOptions: {
    allPropertiesFetchMode: 'latest_version',
    includeAllProperties: true
  },
  filterGroups: [{
    filters: [{
      operator: 'EQ',
      property: 'hs_saved_audience_id',
      value: audienceId.toString()
    }, {
      operator: 'EQ',
      property: 'hs_is_reusable',
      value: 'true'
    }]
  }]
}, overrides);
export const getAudienceFromCrm = (audienceId, query = {}) => http.post(CRM_SEARCH_URL, {
  data: createPayload(audienceId, query)
}).then(response => response.results[0]);